import React, { Component } from 'react';
import { POItemInfo } from './POItemInfo';

export class ScanTote extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //Add event listener to trigger submit button when enter key is pressed
        var scanToteField = document.getElementById("scanTote");
        if (scanToteField) {
            scanToteField.addEventListener("keyup", function (event) {
                event.preventDefault();
                if (event.keyCode === 13) {
                    document.getElementById("nametag-tote-submit-button").click();
                }
            });
        }

    }

    componentWillUnmount() {
        //remove event listener when component unmounts
        var scanToteField = document.getElementById("scanTote");
        if (scanToteField) {
            document.getElementById("scanTote").removeEventListener("keyup", function (event) {
                event.preventDefault();
                if (event.keyCode === 13) {
                    document.getElementById("nametag-tote-submit-button").click();
                }
            });
        }
    }


    render() {
        if (this.props.toteId) {
            return (
                <div className="approval-in-process-info">
                    <h1>{this.props.POInfo.poNumber} Receiving is ALREADY IN PROCESS</h1>
                    <h1>PO is Placed in Tote {this.props.toteId}</h1>
                    <div className="approval-in-process-buttons">
                        <button className="approval-in-process-back-button" onClick={this.props.resetState}>Go Back</button>
                        <button className="approval-in-process-continue-button" onClick={this.props.continueReceiving}>Continue Receiving.</button>
                    </div>
                </div>
            )
        }
        else {
            return (
                < div className="po-scan-tote" >
                    <h1 className='title'>Scan Tote ID</h1>
                    <div className="po-scan-tote-info">
                        <button onClick={this.props.resetState}>Back</button>
                        <input autoComplete="off" id="scanTote" autoFocus name="scanTote" value={this.props.userInput} onChange={(event) => this.props.updateInputValue(event.target.value)}></input>
                        <button id="nametag-tote-submit-button" type="submit" onClick={this.props.assignTote} className='submit'>Submit</button>
                    </div>
                </div >
            );
        }
        
    }
}